export default __webpack_public_path__ + "static/media/bx_task.5aa3b076.svg";